import { PTableHead, PTableHeadRow } from "@porsche-design-system/components-react"
import { defineMessages, FormattedMessage } from "react-intl"
import { TableHeadCellFixed } from "src/components/tableCellFixed/TableCellFixed"
import { TableSortingButton } from "src/components/tableSortingButton/TableSortingButton"
import { vehicleHistoryListColumns } from "./vehicleHistoryListColumns.const"

const messages = defineMessages({
	headerDateTime: {
		defaultMessage: "Date/Time",
		id: "vehicleHistoryList.header.dateTime",
	},
	headerDetails: {
		defaultMessage: "Details",
		id: "vehicleHistoryList.header.details",
	},
	headerEvent: {
		defaultMessage: "Event",
		id: "vehicleHistoryList.header.event",
	},
	headerTrigger: {
		defaultMessage: "Trigger",
		id: "vehicleHistoryList.header.trigger",
	},
})

interface VehicleHistoryListTableHeadProps {
	timeZone?: string
}

export const VehicleHistoryListTableHead = ({ timeZone }: VehicleHistoryListTableHeadProps) => (
	<PTableHead>
		<PTableHeadRow>
			<TableHeadCellFixed $isFixed $width={vehicleHistoryListColumns.dateTime}>
				<TableSortingButton readonly direction="DESC">
					{timeZone ? (
						<>
							<FormattedMessage {...messages.headerDateTime} /> ({timeZone})
						</>
					) : (
						<FormattedMessage {...messages.headerDateTime} />
					)}
				</TableSortingButton>
			</TableHeadCellFixed>
			<TableHeadCellFixed $width={vehicleHistoryListColumns.event}>
				<FormattedMessage {...messages.headerEvent} />
			</TableHeadCellFixed>
			<TableHeadCellFixed $width={vehicleHistoryListColumns.details}>
				<FormattedMessage {...messages.headerDetails} />
			</TableHeadCellFixed>
			<TableHeadCellFixed $width={vehicleHistoryListColumns.trigger}>
				<FormattedMessage {...messages.headerTrigger} />
			</TableHeadCellFixed>
		</PTableHeadRow>
	</PTableHead>
)
